import React from 'react'
import Pagetitle from '../components/pagetitle/Pagetitle'
import Servicedetail from '../components/servicedetail/Servicedetail'
import webdevelopmentimg from './../Images/web-development-6bec95638d8cf66ac55633dc8e763cac.png'
export default function Webdevelopment() {
  const servicetechnologies = ['HTML5' , 'CSS3' , 'JavaScript' , 'Reactjs' , 'Redux' , 'Typescript' , 'Firebase', 'Nodejs' , 'MongoDB']
  return (
    <div>
      <Pagetitle pagename="Web Development" parentpage="Home" />
      <Servicedetail serviceimg={webdevelopmentimg} servicesabout="Making software programs are not an easy job, but our Software developers are very experienced and familiar with all modern tools" technologies={servicetechnologies}/>
    </div>
  )
}
